import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function SlugCard() {
  const { slug } = useParams();
  const [uid, setUid] = useState(undefined);

  useEffect(() => {
    api.get(`/public/slug/${slug}`)
      .then((r) => setUid(r.data.user_id))
      .catch(() => setUid(null));
  }, [slug]);

  if (uid === undefined) {
    return <div className="min-h-screen bg-ink flex items-center justify-center"><span className="font-mono text-xs uppercase tracking-[0.3em] text-ash animate-pulse">Loading…</span></div>;
  }
  if (!uid) return <Navigate to="/" replace />;
  return <Navigate to={`/showcase/${uid}`} replace />;
}
